module.exports = __webpack_public_path__ + "static/media/undraw_task.a0705ef8.svg";